export default __webpack_public_path__ + "static/UCC_EP_WHITE-e8e8d6e550c39d234e9b00bf213991cc.png";